import { createAPI } from '@common'
export default {
  // 音视频选择-左侧树root
  getTreeRootOfE5Cats: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0f60dbut', 'GET', config),
  // 音视频选择-左侧树
  getTreeOfE5Cats: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0f60dbut0tvct', 'GET', config),
  // 音视频选择-右侧列表查询
  postListOfE5ListData: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0f60mjtuebub', 'POST', config),
  // 视频详情
  getVideoDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0w20nbn0tel0wjefp0efubjm', 'POST', config),
  // 音频详情
  getAudioDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0w20nbn0tel0bvejp0efubjm', 'POST', config),
  // 视频-点击左侧-上传权限
  getOperateAction: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.wjefp0f60bdujpot', 'get', config, {
      neverLoading: true
    })
}
